<template>
    <div>
        <v-menu offset-y :nudge-bottom="6">
            <template v-slot:activator="{ on, attrs }">
                <v-btn text small v-bind="attrs" v-on="on">
                    <v-icon small class="mr-1">mdi-view-list-outline</v-icon>
                    <span class="text-truncate" style="max-width: 150px;">{{ nomeAtiva }}</span>
                    <span v-if="sujo" class="primary--text ml-1" title="Alterações não salvas">•</span>
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </template>

            <v-list dense>
                <v-list-item @click="$emit('padrao')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small v-if="!ativaId">mdi-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Padrão</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-for="item in itens"
                    :key="item.id"
                    @click="$emit('aplicar', item.id)"
                >
                    <v-list-item-icon class="mr-2">
                        <v-icon small v-if="item.id === ativaId">mdi-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.nome }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="my-1"/>

                <v-list-item :disabled="!ativaId || !sujo" @click="$emit('salvar')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-content-save</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Salvar alterações</v-list-item-title>
                </v-list-item>

                <v-list-item @click="abrir('nova')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Salvar como nova...</v-list-item-title>
                </v-list-item>

                <v-list-item :disabled="!ativaId" @click="abrir('renomear')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Renomear</v-list-item-title>
                </v-list-item>

                <v-list-item :disabled="!ativaId" @click="abrir('duplicar')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-content-duplicate</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Duplicar</v-list-item-title>
                </v-list-item>

                <v-list-item :disabled="!ativaId" @click="remover">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="red">mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="red--text">Excluir</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-dialog v-model="dialogo" max-width="420" @keydown.esc="dialogo = false">
            <v-card>
                <v-card-title class="text-subtitle-1">{{ tituloDialogo }}</v-card-title>

                <v-divider/>

                <v-card-text class="pt-4">
                    <v-text-field
                        ref="campoNome"
                        v-model="nome"
                        label="Nome da predefinição"
                        :error-messages="erro"
                        outlined
                        dense
                        autofocus
                        @keypress.enter="confirmar"
                    />
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn text small @click="dialogo = false">Cancelar</v-btn>
                    <v-btn color="primary" small @click="confirmar">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'PredefinicoesMenu',

    props: {
        itens: {
            type: Array,
            default: () => [],
        },

        ativaId: {
            type: String,
            default: null,
        },

        sujo: {
            type: Boolean,
            default: false,
        },

        nomeEmUso: {
            type: Function,
            required: true,
        },
    },

    data: () => ({
        dialogo: false,
        modo: 'nova',
        nome: '',
        erro: '',
    }),

    computed: {
        ativa() {
            return this.itens.find(i => i.id === this.ativaId) || null;
        },

        nomeAtiva() {
            return this.ativa ? this.ativa.nome : 'Padrão';
        },

        tituloDialogo() {
            if (this.modo === 'renomear') return 'Renomear predefinição';
            if (this.modo === 'duplicar') return 'Duplicar predefinição';
            return 'Nova predefinição';
        },
    },

    watch: {
        nome() {
            this.erro = '';
        },
    },

    methods: {
        abrir(modo) {
            this.modo = modo;
            this.erro = '';

            if (modo === 'renomear') {
                this.nome = this.ativa ? this.ativa.nome : '';
            } else if (modo === 'duplicar') {
                this.nome = this.ativa ? `${this.ativa.nome} (cópia)` : '';
            } else {
                this.nome = '';
            }

            this.dialogo = true;
        },

        confirmar() {
            const nome = this.nome.trim();

            if (!nome) {
                this.erro = 'Informe um nome';
                return;
            }

            const ignorar = this.modo === 'renomear' ? this.ativaId : null;

            if (this.nomeEmUso(nome, ignorar)) {
                this.erro = 'Já existe uma predefinição com esse nome';
                return;
            }

            this.$emit(this.modo === 'nova' ? 'salvar-como' : this.modo, nome);
            this.dialogo = false;
        },

        async remover() {
            if (!this.ativa) {
                return;
            }

            const ok = await this.$root.$confirm(
                'Excluir predefinição',
                `Excluir "${this.ativa.nome}"? As colunas e filtros salvos nela serão perdidos.`,
                { color: 'red darken-1' },
            );

            if (ok) {
                this.$emit('remover', this.ativaId);
            }
        },
    },
};
</script>
